<div fxLayout="column" class="full-height" fxLayoutAlign="center center">
  <h1 escCustomId="page_not_found" class="mat-headline">There's nothing here. 👨🏽‍💻</h1>

  <div fxLayout="row" fxLayoutGap="25px">
    <button escCustomId="go_back" mat-raised-button (click)="goBack()">Go Back</button>
    <button escCustomId="go_home" color="primary" mat-raised-button routerLink="/">Go Home</button>
  </div>
</div>